module.exports = __webpack_public_path__ + "img/img_32419_0_25.71b681da.png";